export const dateFormmater = (date) => {
    const splitter = date?.split('-');
    return addZero(splitter[2]) + '/'+ addZero(splitter[1]) +'/'+ splitter[0]
}
export const actualDateFormmater = (date) => {
    const splitter = date?.split('/');
    const day = (splitter[0].length === 2) ? splitter[0] : '0' + splitter[0];
    return addZero(splitter[2]) + '-'+ addZero(splitter[1]) +'-'+ day
}

const addZero = (number) => {
    return (number.length === 1) ? '0'+number : number
}